import React from 'react';
import '../product-description.css';

/** Plain-text catalogue formatting; never interpret product copy as HTML. */
export default function ProductDescription({ text }: { text?: string }) {
  const lines = (text || 'Contact our team for product specifications and compatibility advice.')
    .replace(/\\n/g, '\n').replace(/\\t/g, ' ').split(/\r?\n/);
  const blocks: React.ReactNode[] = [];
  const headings: {title:string;id:string}[]=[];
  const prefix=React.useId();
  let paragraph: string[] = [];
  let bullets: string[] = [];
  const flushParagraph = () => {
    if (paragraph.length) blocks.push(<p key={blocks.length}>{paragraph.join(' ')}</p>);
    paragraph = [];
  };
  const flushBullets = () => {
    if (bullets.length) blocks.push(<ul key={blocks.length}>{bullets.map((value, index) => <li key={index}>{value}</li>)}</ul>);
    bullets = [];
  };
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) { flushParagraph(); flushBullets(); continue; }
    const heading = line.match(/^#{1,3}\s+(.+)$/);
    const bullet = line.match(/^[-*•]\s+(.+)$/);
    if (heading) {
      flushParagraph(); flushBullets();
      const id=`${prefix}-section-${headings.length}`;
      headings.push({title:heading[1],id});
      blocks.push(<h2 id={id} key={blocks.length} style={{scrollMarginTop:24}}>{heading[1]}</h2>);
    } else if (bullet) {
      flushParagraph(); bullets.push(bullet[1]);
    } else {
      flushBullets(); paragraph.push(line);
    }
  }
  flushParagraph(); flushBullets();
  return <div className="product-description">{headings.length>1&&<nav className="pd-section-links" aria-label="Product detail sections">{headings.map(h=><a key={h.id} href={`#${h.id}`}>{h.title}</a>)}</nav>}{blocks}</div>;
}

export function productSummary(text?: string): string {
  return (text || '').replace(/\\n/g, '\n').split(/\r?\n/)
    .map(line => line.trim()).filter(line => line && !/^#{1,3}\s/.test(line))
    .find(line => !/^[-*•]\s/.test(line))?.replace(/^\*\*(.*?)\*\*$/, '$1') || '';
}
